import { render, staticRenderFns } from "./ReferralChain.vue?vue&type=template&id=53bcc521&scoped=true&"
import script from "./ReferralChain.vue?vue&type=script&lang=js&"
export * from "./ReferralChain.vue?vue&type=script&lang=js&"
import style0 from "./ReferralChain.vue?vue&type=style&index=0&id=53bcc521&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bcc521",
  null
  
)

export default component.exports